import { Autocomplete, Box, Popper, TextField, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { clientsAPI } from 'api/clientsAPI'
import { forwardRef } from 'react'

export const ClientSelect = forwardRef<HTMLDivElement, any>(
  function ClientSelect(
    {
      value,
      onChange,
      label,
      id,
      platformId,
      ...props
    }: {
      value: number | null
      onChange: (code: number | null) => void
      label: 'string'
      id: string
      platformId?: number
      props: any
    },
    ref,
  ) {
    const popper = (props: any) => {
      return <Popper {...props} placement="bottom-start" />
    }

    const { data } = useQuery({
      enabled: true,
      queryKey: ['getClientsSelector', platformId],
      staleTime: 0,
      queryFn: async () => {
        const response = platformId
          ? await clientsAPI.getClientsByPlatformId(platformId, 1000)
          : await clientsAPI.getClients()
        return (response as any).data.value
      },
    })

    const options = Array.isArray(data) ? data : []
    const selectedClient =
      options.find((client: any) => client?.id === value) ?? null

    return Array.isArray(data) ? (
      <Autocomplete
        ref={ref}
        id={id}
        sx={{ width: 500 }}
        size={props.size}
        PopperComponent={popper}
        value={selectedClient}
        options={options}
        autoHighlight
        isOptionEqualToValue={(option: any, val: any) => option?.id === val?.id}
        onChange={(_e, option: any | null) => {
          onChange(option ? option.id : null)
        }}
        getOptionLabel={(option: any) =>
          option?.companyName ? String(option.companyName) : ''
        }
        renderOption={(props, option) => {
          return (
            <Box
              key={option.id}
              component="li"
              sx={{
                display: 'flex',
                alignItems: 'flex-start !important',
                flexDirection: 'column',
              }}
              {...props}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <Typography noWrap>{option.companyName}</Typography>
              </Box>
            </Box>
          )
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
              label={label}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off',
              }}
              required={props.required}
              error={props.error}
              helperText={props.helperText}
            />
          )
        }}
      />
    ) : (
      <></>
    )
  },
) as (props: any & { ref?: React.Ref<HTMLDivElement> }) => JSX.Element
